/**
 * SearchResultsText component.
 */
import Colors from '@shared/assets/style/default/color';
import Fonts from '@shared/assets/style/default/fonts';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled search results text.
 */
const SearchResultsText = styled.span`
  align-self: center;
  color: ${Colors['text']};
  font-family: ${Fonts['regular']};
  font-size: ${24 * Screen.widthRatio}px;
  margin-left: ${26 * Screen.widthRatio}px;
  overflow: hidden;
  position: relative;
  text-align: right;
  text-overflow: ellipsis;
  top: ${-3 * Screen.widthRatio}px;
  white-space: nowrap;
  width: ${618 * Screen.widthRatio}px;
`;

export default SearchResultsText;
